import dayjs from 'dayjs';

/**
 * Status helpers for trade records (contrataciones / campañas).
 */

/** `true` when the date is before today (contrataciones / campañas vencidas). */
export const isExpired = (date) => {
    if (!date) return false;
    return dayjs(date).isBefore(dayjs(), 'day');
};

/** Tone for a compliance / coverage percentage: ≥70 good, ≥50 attention, otherwise bad. */
export const rateTone = (value) => (value >= 70 ? 'success' : value >= 50 ? 'warning' : 'danger');

/** Status pill data for a contract / campaign record. `labels` lets each screen keep its own wording. */
export const recordStatus = (record, labels = { expired: 'Expirado', active: 'Activo', inactive: 'Inactivo' }) => {
    if (isExpired(record?.expirationDate)) return { tone: 'warning', label: labels.expired, key: 'expired' };
    return record?.active ? { tone: 'success', label: labels.active, key: 'active' } : { tone: 'danger', label: labels.inactive, key: 'inactive' };
};
